// extracted by mini-css-extract-plugin
export default {"wrapper":"MavenirConfigTree_wrapper__AvPzJ","buttonWrapper":"MavenirConfigTree_buttonWrapper__HgsXO","flatTreeWrapper":"MavenirConfigTree_flatTreeWrapper__AmCXw"};